import { render, staticRenderFns } from "./DataResume.vue?vue&type=template&id=3164b863"
import script from "./DataResume.vue?vue&type=script&lang=js"
export * from "./DataResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports